import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { getBool } from 'styles';
import { ItemColumn } from '../layout';
import { TitleSecondary, Detail } from '../text';

const Container = styled(ItemColumn)`
  width: 100%;
  flex-shrink: 0;
  cursor: pointer;
  align-items: flex-start;
  ${getBool('underline', `text-decoration: underline;`)};
`;

const Listing = ({
  date,
  id,
  isHovered,
  isSelected,
  onClick,
  onMouseEnter,
  onMouseLeave,
  title,
}) => (
  <Container
    onClick={() => onClick(id)}
    onMouseEnter={() => onMouseEnter(id)}
    onMouseLeave={onMouseLeave}
    underline={isHovered || isSelected}
    sp={1}
  >
    <TitleSecondary>{title}</TitleSecondary>
    <Detail>{date}</Detail>
  </Container>
);

Listing.propTypes = {
  date: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  isHovered: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default Listing;
